/**
 * 生成画像のテクスチャ（src/assets/textures/<名前>.webp など）。置いてあるものだけをビルド時に拾う。
 * 名前と仕様は docs/design/asset-prompts.md を参照。
 */
const FILES = import.meta.glob<string>('../assets/textures/*.{webp,jpg,jpeg,png}', {
  eager: true,
  query: '?url',
  import: 'default',
})

export type AssetName = 'bookshelf-wall' | 'floor-wood' | 'tabletop' | 'coffee-top' | 'paper'

/** 置いてあればその URL、無ければ null（手続き的に描いたものを使う） */
export function assetUrl(name: AssetName): string | null {
  for (const [path, url] of Object.entries(FILES)) {
    if (path.slice(path.lastIndexOf('/') + 1).replace(/\.\w+$/, '') === name) return url
  }
  return null
}
